import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Simulate } from '@usimweb/core/models';
import { InputType } from '../../../../core/enums/inpuTypeEnum';
import { ApiService } from '@usimweb/core/services';

@Component({
    selector: 'app-simulate',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './simulate.component.html',
    styleUrls: ['./simulate.component.scss'],
    standalone: false
})
export class SimulateComponent implements OnInit, OnChanges {
  @Input() cpus: {} = {};

  @Input() defaultCpu: number = 0;

  @Input() credits: number = 0;

  @Input() appType: string = '';

  @Output() selectionChangeSimTime: EventEmitter<any> = new EventEmitter<any>();

  @Output() updateSimulate: EventEmitter<any> = new EventEmitter<any>();

  public appTypes: string[] = [];
  public simulate: Simulate = {
    name: '',
    simulationTime: 60,
    cpus: 0,
    outPutTime: 1,
    appType: this.appType,
    credits: 0,
  };

  public inputType = InputType;
  public visibility = [
    { key: false, value: 'private' },
    { key: true, value: 'public' },
  ];

  public key = 'key';
  public value = 'value';

  public simTimeToolTip: string = 'Defines the simulation duration...';
  public outputTimeToolTip: string = 'Defines the amount of frames in the simulation, depends on simulation time...';
  public creditsToolTip: string = 'Approximately charge credits for this simulation...';

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.getAppTypes();
    this.setDefautCpus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['defaultCpu'] && this.simulate) {
      this.simulate.cpus = this.defaultCpu;
    }

    if (changes['credits'] && this.simulate) {
      this.simulate.credits = this.credits;
    }

    if (changes['appType'] && this.appType) {
      this.simulate.appType = this.appType;
    }
  }

  private setDefautCpus() {
    this.defaultCpu = 16;

    this.cpus = [
      {
        key: 16,
        value: 'default (16)',
      },
    ];
  }

  public getAppTypes() {
    const subscription = this.apiService.getAppTypes().subscribe((result) => {
      subscription.unsubscribe();
      this.appTypes = result;
    });
  }

  public selectionChangedSimTime(event: number) {
    this.simulate.simulationTime = event;
    this.selectionChangeSimTime.emit(event);
  }

  public blur() {
    this.updateSimulate.emit(this.simulate);
  }
}
